import getErrorsListFromError from "./getErrorsListFromError";
export default function mapValidationErrors(e, callback) {
    var errors = getErrorsListFromError(e);
    Object.entries(errors)
        .forEach(function (_a) {
        var k = _a[0], v = _a[1];
        return callback(k, v);
    });
}
//# sourceMappingURL=mapValidationErrors.js.map